module.exports = __webpack_public_path__ + "img/altavoz.8d95b342.svg";